module.exports = __webpack_public_path__ + "img/d1.e152ef66.jpg";